import { defineComponent as _defineComponent } from 'vue'
import SortIcon from "~/assets/svg/sort-solid.svg?inline";
import SortDownIcon from "~/assets/svg/sort-down-solid.svg?inline";
import SortUpIcon from "~/assets/svg/sort-up-solid.svg?inline";
import {computed, useRoute} from "@nuxtjs/composition-api";

type OrderType = false | "asc" | "desc";

type ExtraQuery = Record<string, any>;



export default /*#__PURE__*/_defineComponent({
  __name: 'sorter',
  props: {
    order: { type: [Boolean, String], default: false },
    allowedOrders: { default: () => [false, "desc", "asc"] },
    type: { default: "link" },
    name: { default: 'sort' },
    extraQuery: { default: () => ({}) }
  },
  emits: ["sort"],
  setup(__props: any, { expose, emit }: { emit: ({
  (name: "sort", order: OrderType): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { order: OrderType, allowedOrders: Array<OrderType>, type: "link" | "button", name: string, extraQuery: ExtraQuery }






// const realOrder = computed(() => {
//   return !props.order ? "unordered" : props.order;
// });
const route = useRoute();
const to = computed(() => {
  return {
    path: route.value.path,
    query: {
      ...props.extraQuery,
      [props.name]: getOrderValue(),
    }
  }
})

// const realAllowedOrders = computed(() => {
//     return props.allowedOrders.filter(Boolean)
// })
const getOrderValue = () => {
  // -1 + 1 = 0, 正好取第一个
  let orders = props.allowedOrders;
  let index = orders.indexOf(props.order);
  return orders[(index + 1) % orders.length]
}
const sort = () => {
  emit("sort", getOrderValue());
};


const onClick = () => {
}
expose({
  sort,
});

return { __sfc: true,props, emit, route, to, getOrderValue, sort, onClick, SortIcon, SortDownIcon, SortUpIcon }
}

})